/** THE NINETY 05 — native, motion-safe, frame-budgeted editorial interactions. */
(() => {
  'use strict';
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const fine = matchMedia('(pointer: fine)');
  const page = document.documentElement;
  const $ = (q, root=document) => root.querySelector(q);
  const $$ = (q, root=document) => [...root.querySelectorAll(q)];
  const max = (lo,x,hi) => Math.max(lo,Math.min(hi,x));
  const easing = 'cubic-bezier(.19,1,.22,1)';
  let lastScroll = scrollY, lastTime = performance.now(), velocity = 0;
  let frame = false;
  const alive = () => !reduce.matches && !window.Shopify?.designMode;

  function cards() {
    const items=$$('.ninety-real-card');
    if(!('IntersectionObserver' in window)){
      items.forEach(card=>card.classList.add('n5-seen'));
      return;
    }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('n5-seen');
        observer.unobserve(entry.target);
      });
    },{rootMargin:'40px 0px',threshold:.04});
    items.forEach(el=>observer.observe(el));
  }

  function initial() {
    const head=$('.ninety-opening .superword');
    if(!head || !alive())return;
    // Keep actual title text intact for accessibility and responsive typesetting.
    const text=head.querySelector('span');
    if(text)text.style.animationDelay='80ms';
  }

  const tick = time => {
    frame=false;
    const y=scrollY;
    const elapsed=Math.max(16,time-lastTime);
    const delta=y-lastScroll;
    velocity+=(delta/elapsed*1000-velocity)*.18;
    lastScroll=y;lastTime=time;
    const speed=max(-1300,velocity,1300);
    page.style.setProperty('--n5-velocity',(speed/1300).toFixed(3));
    if(!alive())return;
    const opening=$('.ninety-opening');
    const title=$('.ninety-opening .superword');
    if(opening && title){
      const box=opening.getBoundingClientRect();
      if(box.bottom>0 && box.top<innerHeight){
        const p=max(0,-box.top/Math.max(box.height,1),1);
        title.style.transform=`translate3d(0,${(p*-14).toFixed(2)}px,0) scale(${(1-p*.035).toFixed(4)})`;
      }
    }
    // Only visible images receive scroll-linked transforms.
    $$('.ninety-real-card.n5-seen').forEach((card,i)=>{
      const rect=card.getBoundingClientRect();
      if(rect.bottom < -80 || rect.top>innerHeight+80)return;
      const relative=(rect.top+rect.height*.5-innerHeight*.5)/Math.max(innerHeight,1);
      const movement=-relative*(i%2===0?11:18);
      card.style.setProperty('--n5-image-y',movement.toFixed(2)+'px');
    });
    $$('.n5-velocity-type').forEach(el=>{
      const rect=el.getBoundingClientRect();
      if(rect.bottom<0||rect.top>innerHeight)return;
      el.style.setProperty('--n5-skew',(-max(-1,speed/1200,1)*1.6).toFixed(3)+'deg');
    });
    const marquee=$('.marquee-track');
    if(marquee){
      const m=marquee.getBoundingClientRect();
      if(m.bottom>0&&m.top<innerHeight){
        marquee.style.setProperty('animation-duration',(Math.max(13,30-Math.abs(speed)/120)).toFixed(1)+'s');
      }
    }
  };
  const handleScroll=()=>{if(!frame){frame=true;requestAnimationFrame(tick)}};

  function prepareType(){
    $$('.ninety-campaign-copy h2,.section-title,.oversized-footer-banner h2,.foot-title,.n5-lookbook-title h2').forEach(e=>e.classList.add('n5-velocity-type'));
  }

  function lookbook(section) {
    if(section.dataset.n5Initialized)return;
    section.dataset.n5Initialized='1';
    const track=$('[data-n5-track]',section), slides=$$('[data-n5-slide]',section);
    const prev=$('[data-n5-prev]',section),next=$('[data-n5-next]',section),counter=$('[data-n5-counter]',section);
    if(!track||!slides.length)return;
    let index=0;
    const set=(i,scroll=true)=>{
      index=max(0,i,slides.length-1);
      slides.forEach((s,j)=>s.classList.toggle('n5-selected',index===j));
      if(counter)counter.textContent=String(index+1).padStart(2,'0')+' / '+String(slides.length).padStart(2,'0');
      if(prev)prev.disabled=index===0;
      if(next)next.disabled=index===slides.length-1;
      if(scroll){
        const target=slides[index];
        track.scrollTo({left: target.offsetLeft-track.offsetLeft-track.clientWidth/2+target.clientWidth/2,behavior:reduce.matches?'auto':'smooth'});
      }
    };
    prev?.addEventListener('click',()=>set(index-1));
    next?.addEventListener('click',()=>set(index+1));
    let settling;
    track.addEventListener('scroll',()=>{
      clearTimeout(settling);
      settling=setTimeout(()=>{
        const center=track.scrollLeft+track.clientWidth/2;
        let best=Infinity,i=0;
        slides.forEach((slide,j)=>{
          const distance=Math.abs(center-(slide.offsetLeft-track.offsetLeft+slide.clientWidth/2));
          if(distance<best){best=distance;i=j;}
        });
        set(i,false);
      },100);
    },{passive:true});
    track.addEventListener('keydown',e=>{
      if(e.key==='ArrowRight'){e.preventDefault();set(index+1)}
      if(e.key==='ArrowLeft'){e.preventDefault();set(index-1)}
    });
    // Native overflow + CSS snap handles swipe, inertia and touch naturally.
    set(0,false);
  }

  function sizeChips() {
    $$('.ninety-product-option').forEach(select => {
      if(select.dataset.n5Chips||!select.options.length || select.options.length>18)return;
      const wrapper=document.createElement('div');wrapper.className='n5-size-chips';wrapper.setAttribute('role','group');
      wrapper.setAttribute('aria-label',select.closest('.field-block')?.querySelector('label')?.textContent?.trim()||'Product options');
      [...select.options].forEach(opt => {
        let b=document.createElement('button');b.type='button';b.className='n5-size-chip';b.textContent=opt.textContent;
        b.setAttribute('aria-pressed',String(opt.value===select.value));
        b.addEventListener('click',()=>{
          select.value=opt.value;
          select.dispatchEvent(new Event('change',{bubbles:true}));
        });
        wrapper.append(b);
      });
      select.dataset.n5Chips='yes';
      select.parentElement.insertBefore(wrapper,select);
      const sync=()=>$$('.n5-size-chip',wrapper).forEach((b,i)=>b.setAttribute('aria-pressed',String(select.options[i].value===select.value)));
      select.addEventListener('change',sync);
    });
  }

  function enablePageTransitions(){
    const wipe=$('#n5-page-wipe');
    if("onpageswap" in window)return;
    if(!wipe || !alive()||document.body.dataset.motionTransitions!=='true')return;
    document.addEventListener('click',e=>{
      if(e.defaultPrevented || e.button!==0 || e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
      const a=e.target.closest('a[href]');if(!a)return;
      if(a.hasAttribute('download')||a.target||a.dataset.nbacktop!==undefined||a.dataset.ndrawer)return;
      const dest=new URL(a.href,location.href);
      if(dest.origin!==location.origin||dest.pathname.startsWith('/checkout')||dest.pathname.startsWith('/account')||dest.pathname.startsWith('/cart/change')||dest.pathname===location.pathname && dest.search===location.search)return;
      if(a.href.includes('#') && dest.pathname===location.pathname && dest.search===location.search)return;
      if(!dest.pathname.startsWith('/'))return;
      e.preventDefault();
      wipe.classList.add('enter');
      setTimeout(()=>{location.assign(dest.href)},390);
    },true);
    if(document.referrer){const origin=(()=>{try{return new URL(document.referrer).origin}catch{return ''}})();
      if(origin===location.origin){wipe.classList.add('exit');setTimeout(()=>wipe.classList.remove('exit'),620)}
    }
  }

  function magnetic(){
    if(!fine.matches||!alive()||document.body.dataset.motionPointer!=='true')return;
    $$('.n5-lookbook-controls button,.ninety-opening-bottom a,.nine-no-wrap,.btn').forEach(btn=>{
      if(btn.dataset.n5Magnetic)return;
      btn.dataset.n5Magnetic='1';
      btn.addEventListener('pointermove',e=>{
        const r=btn.getBoundingClientRect();
        if(r.width>260)return;
        const x=(e.clientX-r.left-r.width/2)*.085;
        const y=(e.clientY-r.top-r.height/2)*.085;
        btn.style.transform=`translate3d(${x.toFixed(1)}px,${y.toFixed(1)}px,0)`;
      },{passive:true});
      btn.addEventListener('pointerleave',()=>{btn.style.transition=`transform .6s ${easing}`;btn.style.transform='';setTimeout(()=>btn.style.transition='',640)});
    });
  }

  function gallerySwipeHint(){
    const gallery=$('.pdp-gallery');if(!gallery)return;
    if(gallery.children.length<2)return;
    gallery.setAttribute('role','region');gallery.setAttribute('aria-label','Product images');
    gallery.setAttribute('tabindex','0');
    gallery.addEventListener('keydown',e=>{
      if(e.key!=='ArrowRight'&&e.key!=='ArrowLeft')return;
      const item=gallery.querySelector('figure');if(!item)return;
      e.preventDefault();gallery.scrollBy({left:e.key==='ArrowRight'?item.clientWidth:-item.clientWidth,behavior:reduce.matches?'auto':'smooth'});
    });
  }

  const init=()=>{
    page.classList.add('n5-ready');
    
    $$('.n5-lookbook').forEach(lookbook);
    sizeChips();gallerySwipeHint();
    

  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>{init()},{once:true});
  else{init()}
  // Static review prototype can re-render its pages without reloading the theme.
  window.n5PreviewReload=()=>{cards();prepareType();$$('.n5-lookbook').forEach(lookbook);sizeChips();gallerySwipeHint();handleScroll()};
  document.addEventListener('ninety:route:load',()=>{sizeChips();gallerySwipeHint()});
  document.addEventListener('shopify:section:load',e=>{
    if(e.target.querySelector('.n5-lookbook'))e.target.querySelectorAll('.n5-lookbook').forEach(lookbook);
    sizeChips();
  });
})();

